
<template>
  <v-card style="border-radius:12px">
    <v-toolbar flat color="white">
      <v-toolbar-title>Colaboradores</v-toolbar-title>
      <v-divider class="mx-4" inset vertical ></v-divider>
      <div class="flex-grow-1"></div>
      <v-btn rounded color="primary" dark class="mb-2" @click="dialogUser = true">Novo</v-btn>

    </v-toolbar>

    <v-card-text>
      <v-row justify="center" v-if="!allUsers">
        <v-col cols="12" align="center">
          <card-loading ></card-loading>
        </v-col>
      </v-row>
      <settings-table v-if="allUsers" :headers="headers" :items="allUsers" @editing="editing($event)" @deleting="deleting($event)"></settings-table>
    </v-card-text>


    <v-dialog v-model="dialogUser" v-if="dialogUser" scrollable :overlay="false" max-width="600px" transition="dialog-transition" >
      <v-card style="border-radius:12px">
        <v-card-title primary-title>
          <div class="headline mb-0">{{oneUser.id? "Editando colaborador" : "Novo colaborador"}}</div>
        </v-card-title>
        <v-card-text>
          <v-form ref="formEmployee" v-model="valid" lazy-validation>
            <v-text-field :rules="[rules.required]" v-model="oneUser.name" prepend-icon="mdi-account" label="Nome"></v-text-field>
            <v-text-field :rules="[rules.required, rules.email]" v-model="oneUser.email" prepend-icon="mdi-email" label="Email"></v-text-field>
            <v-text-field :rules="[rules.required, rules.cpf]" v-model="oneUser.cpf" prepend-icon="mdi-account-card-details" label="CPF" v-mask="mask_cpf"></v-text-field>
            <v-text-field v-model="oneUser.salary" prepend-icon="mdi-account-card-details" label="Salário" v-currency="currency"></v-text-field>
            <!-- <v-text-field v-model="oneUser.phones" prepend-icon="mdi-account-card-details" label="Contato"></v-text-field> -->
            <input-phone :phones.sync="oneUser.phones"></input-phone>
            <!-- <v-text-field :rules="[rules.required]" v-model="oneUser.salary" prepend-icon="mdi-coin" label="Salário"></v-text-field> -->
            <!-- <v-select     :rules="[rules.required]" v-model="oneUser.role_id" :items="allRoles" item-text="translated" item-value="id" prepend-icon="mdi-account-badge" label="Cargo"></v-select> -->

            <v-dialog v-model="dialog_address" persistent max-width="500px">
              <template v-slot:activator="{ on }">
                <v-text-field v-on="on" :value="oneUser.address.full_address" prepend-icon="mdi-map-marker" label="Endereço"></v-text-field>
              </template>
              <card-address v-if="dialog_address" :address="oneUser.address" @address-sent="oneUser.address = $event, dialog_address=false"></card-address>
            </v-dialog>
          </v-form>
        </v-card-text>
        <v-card-actions class="justify-end">
          <v-btn rounded text color="error" @click="dialogUser = false"> <v-icon left>mdi-close</v-icon> Cancelar</v-btn>
          <v-btn rounded text color="success" @click="submitUser()"> <v-icon left>mdi-content-save</v-icon> Salvar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <dialog-loading v-if="loading" :loadText="loadingText"></dialog-loading>
    
  </v-card>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import Api from '../../api/index'
import { mask } from 'vue-the-mask'
import { CurrencyDirective } from 'vue-currency-input'

export default {
  components: {
    SettingsTable: () => import('@/components/shared/IndexTable'),
    CardAddress: ()=> import('@/components/shared/CardAddress.vue'),
    InputPhone: ()=> import('@/components/shared/InputPhone.vue'),

  },
  directives: {
    mask,
    currency: CurrencyDirective
  },
  data() {
    return {
      currency:{
        currency: null,
        locale: undefined,
        autoDecimalMode: true,
        decimalLength: 2,
        distractionFree:false,
      },
      mask_cpf: '###.###.###-##',
      loading: false,
      loadingText: null,

      dialogUser: false,
      oneUser: null,

      dialog_address:false,

      rules: {
        required: v => !!v || 'Campo é necessário',
        email: v => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'E-mail deve ser válido',
        cpf: v => (v && v.length == 14) || 'CPF deve ser completo',
      },
      valid: true,

      headers:[
        { text: 'Nome', width: '30%' ,align: 'left', sortable: false, value: 'name'},
        { text: 'E-mail', width: '30%' ,align: 'left', sortable: false, value: 'email'},
        { text: 'Cargo', width: '30%' ,align: 'left', sortable: false, value: 'role_name_pt'},
        // { text: 'Dado 1', value: 'calories' },
        // { text: 'Dado 2', value: 'fat' },
        // { text: 'Dado 3', value: 'carbs' },
        // { text: 'Dado 4', value: 'protein' },
        { text: 'Ação', value: 'action', sortable: false },
      ]
    }
  },
  methods: {
    editing(id) {
      this.loading = true
      this.loadingText = "Carregando"
      Api.User.show(id)
        .then(response=>response.data)
        .then(user=>{
          this.oneUser = user//.data.attributes
          this.loading = false
          this.loadingText = null
          this.dialogUser = true
        })
    },
    deleting(id) {
      this.loading = false
      this.loading = true
      this.loadingText = "Apagando"
      setTimeout(() => {
        this.updateToDelete(id)
      }, 1200);
    },
    submitUser(){
      if (this.$refs.formEmployee.validate()){
        this.loading = true
        this.loadingText = 'Salvando'
        if (this.oneUser.id){
          console.log('update');
          this.oneUser.role_ids = [this.oneUser.role_id]
          this.update(this.oneUser)
        } else{
          console.log('create');
          // this.oneUser.role_ids = [this.oneUser.role_id]
          this.create(this.oneUser)
        }
      }
    },
    ...mapActions({
      index: 'User/index',
      indexRoles: 'User/indexRoles',
      create: 'User/create',
      update: 'User/update',
      updateToDelete: 'User/updateToDelete',

      clearAllUsers: 'User/clearAllUsers',
    })
  },
  computed: {
    name() {
      return null 
    },
    ...mapState({
      allUsers: state => state.User.allUsers,
      allRoles: state => state.User.allRoles,

      createUserWasGood: state => state.User.createUserWasGood,
      createUserMessage: state => state.User.createUserMessage,
      updateUserWasGood: state => state.User.updateUserWasGood,
      updateUserMessage: state => state.User.updateUserMessage,
    })
  },
  created () {
    setTimeout(() => {
      this.index()
    }, 2000);
    this.loading = false
    this.indexRoles()
  },
  beforeDestroy () {
    console.log('destroying');
    
    this.clearAllUsers()
  },
  watch: {
    dialogUser(nv,ov) {
      if (nv){
        if (!this.oneUser){
          this.oneUser = {address:{}}
        }
      } else if (nv == false){
        this.oneUser = null
      }
    },
    createUserWasGood(nv,ov) {
      this.loading = false
      this.loadingText= null
      if (nv){
        this.dialogUser = false
        this.$swal({
          toast: true,
          position: 'top-end',
          timer: 3000,
          title: this.createUserMessage? this.createUserMessage : "Criado com sucesso",
          type: "success",
          showConfirmButton: false,
        })
        this.oneUser=null
        this.dialogUser = false
        this.index()
      } else if (nv == false){
        this.$swal({
          toast: true,
          position: 'top-end',
          timer: 6000,
          title: "Houve um erro. "+this.createUserMessage,
          type: "error",
          showConfirmButton: false,
        })
      }
    },
    updateUserWasGood(nv,ov) {
      
      if (nv){
        this.dialogEdit = false
        this.$swal({
          toast: true,
          position: 'top-end',
          timer: 3000,
          title: this.updateUserMessage? this.updateUserMessage :"Atualizado com sucesso",
          type: "success",
          showConfirmButton: false,
        })
        this.dialogUser = false
        this.oneUser=null
        this.loading = false
        this.loadingText= null
        this.index()
      } else if (nv == false){
        this.$swal({
          toast: true,
          position: 'top-end',
          timer: 6000,
          title: "Houve um erro. "+this.updateUserMessage,
          type: "error",
          showConfirmButton: false,
        })
      }
    }
  },
}
</script>

<style scoped>

</style>